<template>
  <div class="scrollable-block">
    <div class="main-block request-management">

      <div class="div col-12 p-0 d-flex align-items-start ">
        <h4 class="">{{ $t('title.changePassword') }}</h4>
      </div>
      <div class="login w-100 h-100 d-flex mt-5">
        <div class="col-12 form-block mx-auto">

          <div class="col-12 col-md-5 mx-auto mt-4">
            <!-- Adjust width here -->
            <b-form @submit.prevent="onSubmit" class="p-4">
              <div class="mb-3 text-left">
                <label for="currentPassword" class="mb-1">Please enter your current password:</label>
                <b-form-input id="currentPassword" type="password" v-model="formFields.currentPassword"></b-form-input>
              </div>

              <div class="mb-3 text-left">
                <label for="password1" class="mb-1">Please enter your new password:</label>
                <b-form-input id="password1" type="password" v-model="formFields.password1"></b-form-input>
              </div>

              <div class="mb-3 text-left">
                <label for="password2" class="mb-1">Please repeat your password:</label>
                <b-form-input id="password2" type="password" v-model="formFields.password2"></b-form-input>
              </div>

              <b-button type="submit" variant="primary" class="mb-3 w-100">Change password</b-button>

              <p class="text-center">
                <router-link :to="{ name: 'Dashboard' }">Back to Home</router-link>
              </p>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Error from '@/Util/Error';
import { request } from '@/Util/Request';
import { mapGetters } from 'vuex';
import { reactive } from 'vue';

export default {
  data() {
    return {
      formFields: reactive({
        currentPassword: '',
        password1: '',
        password2: '',
      }),
      formErrors: new Error({}),
    };
  },
  computed: {
    ...mapGetters(['loader']),
    passwordState() {
      return {
        currentPassword: this.formErrors.first('current_password')
          ? 'is-invalid'
          : this.formFields.currentPassword
            ? 'is-valid'
            : '',
        password1: this.formErrors.first('new_password')
          ? 'is-invalid'
          : this.formFields.password1
            ? 'is-valid'
            : '',
        password2: this.formErrors.first('new_password_confirmation')
          ? 'is-invalid'
          : this.formFields.password2
            ? 'is-valid'
            : '',
      };
    },
  },
  methods: {
    validatePassword() {
      if (!this.formFields.currentPassword) {
        this.formErrors = new Error({
          current_password: ['Current password is required']
        });
        this.formErrors.currentPassword = 'Current password is required';
      } else {
        this.formErrors = new Error({});
      }

      if (!this.formFields.password1 || this.formFields.password1.length < 6) {
        this.formErrors = new Error({
          new_password: ['Password must be at least 6 characters']
        });
      } else {
        this.formErrors = new Error({});
      }

      if (this.formFields.password1 !== this.formFields.password2) {
        this.formErrors = new Error({
          new_password_confirmation: ['Passwords do not match']
        });
      } else {
        this.passwordState.password2 = 'is-valid';
        this.formErrors = new Error({});
      }
    },
    async onSubmit() {
      this.validatePassword();

      try {
        const response = await request({
          method: 'post',
          url: `/admin/change-password`,
          data: {
            current_password: this.formFields.currentPassword,
            new_password: this.formFields.password1,
            new_password_confirmation: this.formFields.password2,
          }
        });

        const { data } = response;

        this.showToast();
        setTimeout(() => {
          this.$router.push({ path: '/' });
        }, 1500);
      } catch (error) {
        if (error.request && error.request.status === 422) {

          // Populate server-provided errors
          if (error.request && error.request.status && error.request.status === 422) {
            this.formErrors = new Error(JSON.parse(error.request.responseText).errors);
            return false;
          }

        } else {
          this.notifyError();
        }
      }

    },
    showToast() {
      const h = this.$createElement;
      const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [
        `Your password was successfully changed`,
      ]);
      // Create the title
      const vNodesTitle = h(
        'div',
        { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
        [h('strong', { class: 'mr-2' }, 'Password changed successfully')]
      );
      // Pass the VNodes as an array for message and title
      this.$bvToast.toast([vNodesMsg], {
        title: [vNodesTitle],
        solid: true,
        variant: 'success',
      });
    },
  },
};
</script>
